import { render } from "./Useraccounts.vue?vue&type=template&id=a4cdddae&ts=true"
import script from "./Useraccounts.vue?vue&type=script&lang=ts"
export * from "./Useraccounts.vue?vue&type=script&lang=ts"

import "./Useraccounts.vue?vue&type=style&index=0&id=a4cdddae&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__